/**
 * Character-based middle truncation
 */
export function truncateMiddle(text: string, maxLength: number, ellipsis = "…"): string {
  if (text.length <= maxLength) return text;

  const ellipsisLength = ellipsis.length;
  const availableLength = maxLength - ellipsisLength;

  if (availableLength <= 0) return ellipsis.slice(0, maxLength);

  const leftLength = Math.ceil(availableLength / 2);
  const rightLength = availableLength - leftLength;

  return text.slice(0, leftLength) + ellipsis + text.slice(-rightLength);
}

/**
 * Fast overflow detection - only checks once on mount
 */
export function truncateByOverflow(element: HTMLElement, text: string, ellipsis = "…"): string {
  element.textContent = text;

  if (element.scrollWidth <= element.clientWidth) {
    return text;
  }

  let maxLength = text.length;
  let minLength = 0;

  while (minLength < maxLength) {
    const midLength = Math.floor((minLength + maxLength + 1) / 2);
    const truncated = truncateMiddle(text, midLength, ellipsis);

    element.textContent = truncated;

    if (element.scrollWidth <= element.clientWidth) {
      minLength = midLength;
    } else {
      maxLength = midLength - 1;
    }
  }

  return truncateMiddle(text, minLength, ellipsis);
}
